import cn from "../../utils/cn"

const tag = "px-2.5 py-0.5 text-xs rounded-full border whitespace-nowrap"

// Sits above the pane's scrollport rather than inside it, so it stays put while
// the body scrolls and the scrollbar stops short of the card's rounded corners.
const LogDetailHeader = ({ log, videos }) => {
  const scans = log.scanSummary

  return (
    <header className="flex shrink-0 flex-wrap items-center gap-2.5 border-b border-gray-200 bg-gray-50 px-5 py-3">
      <span
        className={cn(
          "h-2 w-2 shrink-0 rounded-full",
          log.IsError ? "bg-red-500" : "bg-green-500"
        )}
      />
      <span className="sr-only">{log.IsError ? "Errored" : "Succeeded"}</span>

      <h2 className="text-[15px] font-semibold text-gray-900">
        {log.AccessionNo}
      </h2>

      <span className={cn(tag, "border-blue-200 bg-blue-50 text-blue-700")}>
        {videos.length} video{videos.length !== 1 ? "s" : ""}
      </span>

      {scans?.TotalScans > 0 && (
        <span
          className={cn(tag, "border-green-200 bg-green-50 text-green-700")}
        >
          {scans.TotalScans} scan{scans.TotalScans !== 1 ? "s" : ""} ·{" "}
          {scans.UniqueScans} unique
        </span>
      )}

      {/* Same pill, same condition, as the sidebar row — the header is meant to
          carry forward everything the row promised before it was opened. */}
      {scans?.FeedbackSubmittedAt && (
        <span
          className={cn(tag, "border-purple-200 bg-purple-50 text-purple-700")}
        >
          feedback
        </span>
      )}

      <span className="flex-1" />

      <span className="text-xs text-gray-500">
        {new Date(log.CreatedDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })}
      </span>
    </header>
  )
}

export default LogDetailHeader
